const STRINGS = {
	IMAGEALT: "Image not found",
	LOADING_MATCH_DATA: "Loading Match Data...",
	NO_DATA_AVAILABLE: "No data available for the selected match ID and type. Please try a different match.",
	INVALID_MATCH_ID_TYPE: "Invalid match ID or type",
	NO_SCORECARD_DATA: "No scorecard data available",
	FAILED_TO_FETCH_SCORECARD: "Failed to fetch scorecard: ",
	FAILED_TO_FETCH_FINAL_SCORECARD: "Failed to fetch final scorecard: ",
	SUMMARY_TAB: "Summary",
	SCORECARD_TAB: "Scorecard",
	CRICKSTAR_LOGO_ALT: "Crickstar Logo",
	GOOGLE_LOGO_ALT: "Google Logo",
	LEFT_BANNER_ALT: "Left Banner",
	RIGHT_BANNER_ALT: "Right Banner",
	BOTTOM_BANNER_ALT: "Bottom Banner",
	GOOGLE_PLAY_ALT: "Google Play",
	APP_STORE_ALT: "App Store",
	AD_TITLE: "Cricket. Anytime. Anywhere.",
	AD_SUBTITLE: "Download the app now.",
	TEAM1_LOGO_ALT: "Team1 Logo",
	TEAM2_LOGO_ALT: "Team2 Logo",
	DROPDOWN_ALT: "dropdown",
	TARGET_LABEL: (team1, runs, team2, newTarget) =>
		`<b>${team1}</b> are projected to score <b>${runs}</b> runs. The revised target for <b>${team2}</b> is now set at <b>${newTarget}</b>`,
	MATCH_RESULT: (winningTeam, winBy) => `${winningTeam} won the match by ${winBy}`,
	TIE_RESULT: (winBy) => `${winBy}`,
	PLAYER_OF_MATCH: "Player of the Match",
	PLAYER_LOGO_ALT: "Player of the Match",
	TROPHY_ALT: "Trophy",
	BEST_PERFORMANCE: "Best Performance",
	NO_TOP_BATSMEN: "No top batsmen available",
	NO_TOP_BOWLERS: "No top bowlers available",
	NO_SUMMARY_DATA: "No summary data available",
	BETTING_LINK: "Batting",
	BOWLING_LINK: "Bowling",
	FALL_OF_WICKET_LINK: "Fall of Wicket",
	PARTNERSHIPS_LINK: "Partnerships",
	OVERS_LINK: "Overs",
	BATSMAN_HEADER: "Batsman",
	RUNS_HEADER: "R",
	BALLS_HEADER: "B",
	FOURS_HEADER: "4s",
	SIXES_HEADER: "6s",
	STRIKE_RATE_HEADER: "SR",
	BOWLER_HEADER: "Bowler",
	OVERS_HEADER: "O",
	MAIDENS_HEADER: "M",
	WICKETS_HEADER: "W",
	ECONOMY_HEADER: "Eco",
	SCORE_HEADER: "Score",
	OVER_HEADER: "Over",
	EXTRA_LABEL: "EXTRA",
	EXTRA_HEADER: "Extra",
	BALL_HEADER: "Ball",
	EXTRA_DETAILS: (bye, legBye, wide, noBall) =>
		`(b ${bye}, lb ${legBye}, w ${wide}, nb ${noBall})`,
	NO_FALL_OF_WICKETS: "No fall of wickets available",
	NO_PARTNERSHIP_DATA: "No partnership data available",
	NO_OVERS_DATA: "No overs data available",
	WICKET_SCORE: (overNumber, totalRuns) => `O: ${overNumber}, R: ${totalRuns}`,
	BOWLER_DROPDOWN_ALT: "dropdown",
	BOWLING_HIGHLIGHTS: "Bowling Highlights",
	LOADING_BOWLER_HIGHLIGHTS: "Loading Bowler Highlights...",
	NO_OVER_HISTORY: "No over history available for this bowler",
	MISSING_PARAMETERS: "Missing required parameters: matchId, matchType, or bowler_name",
	FAILED_TO_FETCH_BOWLER_HISTORY: "Failed to fetch bowler history: ",
	NO_OVER_DATA: "No over history data available for this bowler",
	OVER_LABEL: (overNumber) => `Over ${overNumber}`,
	RUNS_LABEL: (totalRun) => `${totalRun} Runs`,
	UNKNOWN_BOWLER: "Unknown Bowler",
	DOT_SEPARATOR: ".",
	NO_DATA_FOUND: "No data found!",
	PLEASE_TRY_AGAIN: "It looks like the data doesn’t exist. Please try again!",
	BACK_ARROW: "go to back",
	GOOGLE_PLAY_URL_RIGHT: "https://play.google.com/store/apps/details?id=com.zennaxx.crickstar.app&hl=en_INraphics 1.0.1 -in&pli=1",
	APP_STORE_URL_RIGHT: "https://apps.apple.com/in/app/crickstar-cricket-scoring-app/id6499577366",
	QUICK_APP_GOOGLE_PLAY_URL_RIGHT: "https://play.google.com/store/apps/details?id=com.zennaxx.crickstar.quickmatch",	
	QUICK_APP_APP_STORE_URL_RIGHT: "https://apps.apple.com/in/app/crickstars-create-quick-match/id6755137096",
	GOOGLE_PLAY_URL_LEFT: "https://play.google.com/store/apps/details?id=com.vocabwords.vocabwords",
	APP_STORE_URL_LEFT: "https://apps.apple.com/in/app/vocab-words/id6474308349",
	GOOGLE_PLAY_URL_BOTTOM: "https://play.google.com/store/apps/details?id=com.threadclothes.android",
	APP_STORE_URL_BOTTOM: "https://apps.apple.com/in/app/threadclothes-women-fashion/id1630780738",
}

export default STRINGS